import { AuthUser, AuthUserSchema } from '@/contexts/auth/auth.types';

const USER: string = '@prydata-User';

export const storeUser = (value: unknown) => {
  localStorage.setItem(USER, JSON.stringify(value));
};

export const getUser = (): AuthUser | null => {
  const json = localStorage.getItem(USER);
  if (!json) return null;

  try {
    const parsed = JSON.parse(json);
    const user = AuthUserSchema.parse(parsed);
    return user;
  } catch (err) {
    console.warn('Usuário inválido no localStorage:', err);
    return null;
  }
};

export const getStoredLanguage = () => {
  return localStorage.getItem('i18nextLng') || 'en';
};
